import axios, { type AxiosRequestConfig } from 'axios'
import { ElMessage } from 'element-plus'

const http = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000/api/v1',
  timeout: 20000
})

/** 请求发出前自动附加 JWT token。 */
http.interceptors.request.use((config) => {
  const token = localStorage.getItem('lingbao_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

http.interceptors.response.use(
  (response) => {
    const body = response.data
    if (body && typeof body.code === 'number') {
      if (body.code === 0) return body.data
      ElMessage.error(body.message || '请求失败')
      return Promise.reject(new Error(body.message || '请求失败'))
    }
    return body
  },
  (error) => {
    const status = error.response?.status
    const message =
      error.response?.data?.message ||
      (status === 401
        ? '登录状态已失效，请重新登录'
        : status === 403
          ? '当前账号没有此操作权限'
          : status
            ? `请求失败，请稍后重试（状态码 ${status}）`
            : '无法连接后端服务，请检查网络或后端是否已启动')
    ElMessage.error(message)
    if (status === 401) {
      localStorage.removeItem('lingbao_token')
      localStorage.removeItem('lingbao_user')
      window.location.href = '/login'
    }
    return Promise.reject(new Error(message))
  }
)

/** 发送 HTTP 请求并返回后端 data 字段。 */
export function request<T>(config: AxiosRequestConfig): Promise<T> {
  return http.request(config) as Promise<T>
}

export default http
